import moment from 'moment';
import React, { Component } from "react";
import 'react-block-ui/style.css';
import Datetime from 'react-datetime';
import LoadingIndicator from '../Components/LoadingIndicator/LoadingIndicator';
import ReportsService from '../utils/ReportsService';
import UsersService from '../utils/UsersService';

const StatTable = (props) => {
  const { title, bookings, totals } = props
  const baseWidth = 600

  const rows = []

  for (const [index, value] of totals.entries()) {
    const hasPercentage = value !== 0 && bookings[index] !== 0
    rows.push(<tr>
      <td>{index}</td>
      <td>{value} / {bookings[index]}</td>
      <td>{hasPercentage && <span>{((value / bookings[index]) * 100).toFixed(2)}%</span>}</td>
      <td style={{
        width: baseWidth
      }}>
        {hasPercentage && <div style={{
          height: 24,
          width: baseWidth / 100 * ((value / bookings[index]) * 100),
          background: 'rgb(110, 148, 185)',
        }}></div>}

      </td>
    </tr>
    )
  }

  return (
    <div style={{
      width: '100%', padding: 20, margin: 10, background: '#fefefe', border: '1px solid #ccc'
    }}>
      <h4 style={{ marginTop: 0 }}>{title}</h4>
      <table className='table table-bordered'>
        <thead>
          <tr>
            <th style={{ width: 100 }}>Days Before</th>
            <th style={{ width: 100 }}>Total</th>
            <th style={{ width: 100 }}>%</th>
            <th style={{ width: baseWidth + 100 }}>Percentage</th></tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    </div>
  )
}


class ReportingDaysBeforeTCS extends Component {
  constructor(props) {
    super(props);
    const defaultFilter = {
      sale_made_by: '',
      region: '',
      date_field: 'created_at',
      start_date: moment().subtract(1, 'month').format("DD MMM YYYY"),
      end_date: moment().subtract(1, 'day').format("DD MMM YYYY")
    }
    this.state = {
      report: props.report,
      filter: defaultFilter,
      data: null,
      coaches: [],
      currentPage: 1,
      totalPages: 1,
      per: 50,
      view: props.view
    };

    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true }, () => {
      this.fetchItems()
      this.fetchCoaches()
      this.fetchVenues()
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.view !== prevProps.view || this.props.report !== prevProps.report) {
      const filter = {
        sale_made_by: '',
        region: '',
        date_field: 'created_at',
        start_date: moment().subtract(1, 'month').format("DD MMM YYYY"),
        end_date: moment().subtract(1, 'day').format("DD MMM YYYY"),
        view: this.props.view
      }
      this.setState({ report: this.props.report, filter: filter, currentPage: 1 }, this.fetchItems)
    }
  }

  handleFilterChange(event) {
    let filter = { ...this.state.filter };
    filter[event.target.id] = event.target.value;
    this.setState({ filter: filter }, this.fetchItems);
  }

  dateFilterChanged(field, value) {
    let filter = { ...this.state.filter };
    filter[field] = value.format("DD MMM YYYY");
    this.setState({ filter: filter, currentPage: 1 }, this.fetchItems);
  }

  fetchItems() {
    this.setState({ loadingInProgress: true });
    ReportsService.daysBeforeTCS({ report: this.state.report, filter: this.state.filter, page: this.state.currentPage, per: this.state.per }).then(data => {
      this.setState({ loadingInProgress: false, data: data });
    });
  }

  fetchCoaches = () => {
    UsersService.allUsers().then(data => {
      this.setState({ coaches: data.filter((c) => c.roles.includes('tcs_coach')).sort((a, b) => (a.name > b.name) ? 1 : -1) })
    });
  }

  fetchVenues = () => {
    ReportsService.venues().then(data => {
      this.setState({ venues: data })
    });
  }

  render() {
    if (!this.state.data || !this.state.coaches || !this.state.venues) return null

    return (
      <LoadingIndicator loadingInProgress={this.state.loadingInProgress}>
        <div>
          <div style={{ marginBottom: "10px" }}>


            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="region"
                value={this.state.filter.region}
                onChange={this.handleFilterChange}
              >
                <option value="">(any region)</option>
                <option value="ACT">Australian Capital Territory (SSC)</option>
                <option value="NSW">New South Wales (HSC)</option>
                <option value="NT">Northern Territory (NTCET)</option>
                <option value="QLD">Queensland (QCE)</option>
                <option value="SA">South Australia (SACE)</option>
                <option value="TAS">Tasmania (TCE)</option>
                <option value="VIC">Victoria (VCE)</option>
                <option value="WA">Western Australia (WACE)</option>
              </select>
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="venue"
                value={this.state.filter.venue}
                onChange={this.handleFilterChange}
              >
                <option value="">(any venue)</option>
                {this.state.venues.map((v) => <option key={v} value={v}>{v}</option>)}
              </select>
            </div>
          </div>
          <div>
            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <Datetime
                inputProps={{ className: '' }}
                onChange={(v) => this.dateFilterChanged('start_date', v)}
                value={this.state.filter.start_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>

            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <Datetime
                inputProps={{ className: '' }}
                onChange={(v) => this.dateFilterChanged('end_date', v)}
                value={this.state.filter.end_date}
                closeOnSelect={true}
                dateFormat="DD MMM YYYY"
                timeFormat={false}
              />
            </div>
            <div style={{ display: 'inline-block', marginRight: 10 }}>
              <select
                id="date_field"
                value={this.state.filter.date_field}
                onChange={this.handleFilterChange}
              >
                <option value="created_at">Created At</option>
              </select>
            </div>
          </div>
        </div>

        <StatTable title={`Presented by Booking Days Before TCS (via ${this.state.report})`} bookings={this.state.data.result.bookings} totals={this.state.data.result.tcs_attended}></StatTable>

      </LoadingIndicator>
    );
  }
}
export default ReportingDaysBeforeTCS
